if (!customElements.get('redirect-modal')) {
  class LocalizationModal extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const countrySelect = document.getElementById('countryLabel');

      countrySelect.addEventListener('change', () => {
        const currentURL = new URL(window.location.href);
        const currentHostname = currentURL.hostname;
        const button = this.querySelector('[data-redirect]')

        const selectedCountry = countrySelect.value;
        let newDomain = currentHostname;
        if (selectedCountry == "us") {
          newDomain = 'orthofeet.com'
        } else if (selectedCountry === 'ca') {
          newDomain = 'ca.orthofeet.com';
        } else if (selectedCountry === 'eu') {
          newDomain = 'de.orthofeet.com';
        } else if (selectedCountry == 'gb') {
          newDomain = 'orthofeet.co.uk';
        }

        const newURL = `https://${newDomain}`;
        button.setAttribute('href', newURL);
      });
    }
  }

  customElements.define('redirect-modal', LocalizationModal);
}
